import type { OptionItem, SubCategoryCode, PackagePriceItem } from './feature-list'

/**
 * 规则效验
 */
export enum RuleButtonType {
  Cancel = 'cancel',
  Add = 'add',
  Jump = 'jump',
  Keep = 'keep',
}
export interface RuleCheckResultItem {
  feature_code: string
  code: string
}
export interface RuleCheckButtonItem {
  name: string
  type: RuleButtonType
  // json 字符串，更改场景返回配置器二级类目code，例如{"sub_category_code":"interior"}
  param?: string
}
export interface RuleOptionItem {
  name?: string
  feature_code: string
  code: string
}

export type EnterPageKey =
  | SubCategoryCode
  | 'designer_alert'
  | 'price_alert'
  | 'configurator_overview'

export interface RuleCheckReq {
  model_code: string
  new_version?: string | number
  generation_code: string
  current_selected_option_list: RuleOptionItem[]
  current_total_price?: number
  new_selected_option_list?: RuleOptionItem[]
  new_cancelled_option_list?: RuleOptionItem[]
  switch_option_list?: RuleOptionItem[]
  enter_page?: EnterPageKey[]
  need_package_popup?: boolean
}

export interface OptionChangePopupConfig {
  category_list: OptionBundleCategory[]
  price_difference_desc?: string
  price_difference?: number
  button_list: RuleCheckButtonItem[]
}

export interface OptionBundleCategory {
  title: string
  type?: string
  sub_title?: string
  bottom_desc?: string
  group_list: OptionBundleGroup[]
}

export interface OptionBundleGroup {
  title: string
  option_list: OptionItem[]
}

export interface RuleCheckRes {
  data: {
    rule_check_tip: string
    rule_check_title: string
    rule_check_result_option_list: RuleCheckResultItem[]
    package_price_list?: PackagePriceItem[]
    non_selectable_option_list?: string[]
    button_list: RuleCheckButtonItem[]
    option_change_toast?: string
    option_change_popup?: OptionChangePopupConfig
    package_popup_url?: string
  }
}
